var _dec, _class, _temp;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { FalsyText, TouchableWeb } from "../../devsupport";
import { Interaction, styled } from "../../theme";
import { CheckMark } from "../shared/checkmark.component";
import { Minus } from "../shared/minus.component";
export
/**
 * Checkboxes allow the user to select one or more items from a set.
 *
 * @extends React.Component
 *
 * @property {boolean} checked - Whether component is checked.
 * Defaults to *false*.
 *
 * @property {(checked: boolean, indeterminate: boolean) => void} onChange - Called when checkbox
 * should switch it's value.
 * Called with *checked* and *indeterminate* values.
 * If *indeterminate* was provided, it should be changed to the value passed in this function.
 *
 * @property {boolean} indeterminate - Whether checked status is indeterminate.
 * Will set indeterminate to false when the checked property is changed.
 * Defaults to *false*.
 *
 * @property {ReactText | (TextProps) => ReactElement} children - String, number or a function component
 * to render near the checkbox.
 * If it is a function, expected to return a Text.
 *
 * @property {string} status - Status of the component.
 * Can be `basic`, `primary`, `success`, `info`, `warning`, `danger` or `control`.
 * Defaults to *basic*.
 * Use *control* status when needed to display within a contrast container.
 *
 * @property {TouchableOpacityProps} ...TouchableOpacityProps - Any props applied to TouchableOpacity component.
 *
 * @overview-example CheckboxSimpleUsage
 *
 * @overview-example CheckboxStates
 * CheckBoxes can be checked or disabled.
 *
 * @overview-example CheckboxIndeterminate
 * An extra state is `indeterminate`, which may be useful for grouping inner checkboxes.
 * Indeterminate will be set to `false` when the checked state is changed.
 *
 * @overview-example CheckboxStatus
 * Checkboxes may also be marked with `status` property, which is useful within forms validation.
 * An extra status is `control`, which is designed to be used on high-contrast backgrounds.
 *
 * @overview-example CheckboxStyling
 * CheckBox and it's inner views can be styled by passing them as function components.
 * ```
 * import { CheckBox, Text } from '../..';
 *
 * <CheckBox>
 *   {evaProps => <Text {...evaProps}>Place your Text</Text>}
 * </CheckBox>
 * ```
 *
 * @overview-example CheckboxTheming
 * In most cases this is redundant, if [custom theme is configured](guides/branding).
 */
let CheckBox = (_dec = styled('CheckBox'), _dec(_class = (_temp = class CheckBox extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "onMouseEnter", event => {
      this.props.eva.dispatch([Interaction.HOVER]);
      this.props.onMouseEnter && this.props.onMouseEnter(event);
    });

    _defineProperty(this, "onMouseLeave", event => {
      this.props.eva.dispatch([]);
      this.props.onMouseLeave && this.props.onMouseLeave(event);
    });

    _defineProperty(this, "onFocus", event => {
      this.props.eva.dispatch([Interaction.FOCUSED]);
      this.props.onFocus && this.props.onFocus(event);
    });

    _defineProperty(this, "onBlur", event => {
      this.props.eva.dispatch([]);
      this.props.onBlur && this.props.onBlur(event);
    });

    _defineProperty(this, "onPress", () => {
      this.props.eva.dispatch([]);
      this.props.onChange && this.props.onChange(!this.props.checked, false);
    });

    _defineProperty(this, "onPressIn", event => {
      this.props.eva.dispatch([Interaction.ACTIVE]);
      this.props.onPressIn && this.props.onPressIn(event);
    });

    _defineProperty(this, "onPressOut", event => {
      this.props.eva.dispatch([]);
      this.props.onPressOut && this.props.onPressOut(event);
    });

    _defineProperty(this, "getComponentStyle", source => {
      const {
        textMarginHorizontal,
        textFontFamily,
        textFontSize,
        textFontWeight,
        textColor,
        iconWidth,
        iconHeight,
        iconBorderRadius,
        iconTintColor,
        outlineWidth,
        outlineHeight,
        outlineBorderRadius,
        outlineBackgroundColor
      } = source,
            containerParameters = _objectWithoutProperties(source, ["textMarginHorizontal", "textFontFamily", "textFontSize", "textFontWeight", "textColor", "iconWidth", "iconHeight", "iconBorderRadius", "iconTintColor", "outlineWidth", "outlineHeight", "outlineBorderRadius", "outlineBackgroundColor"]);

      return {
        selectContainer: containerParameters,
        text: {
          marginHorizontal: textMarginHorizontal,
          fontFamily: textFontFamily,
          fontSize: textFontSize,
          fontWeight: textFontWeight,
          color: textColor
        },
        icon: {
          width: iconWidth,
          height: iconHeight,
          fill: iconTintColor,
          stroke: iconTintColor,
          strokeWidth: 3
        },
        highlight: {
          width: outlineWidth,
          height: outlineHeight,
          borderRadius: outlineBorderRadius,
          backgroundColor: outlineBackgroundColor
        }
      };
    });

    _defineProperty(this, "renderIconElement", style => {
      const Icon = this.props.indeterminate ? Minus : CheckMark;
      return /*#__PURE__*/React.createElement(Icon, style);
    });
  }

  render() {
    const _this$props = this.props,
          {
      eva,
      style,
      disabled,
      children
    } = _this$props,
          touchableProps = _objectWithoutProperties(_this$props, ["eva", "style", "disabled", "children"]);

    const evaStyle = this.getComponentStyle(eva.style);
    return /*#__PURE__*/React.createElement(TouchableWeb, _extends({}, touchableProps, {
      style: [styles.container, style],
      disabled: disabled,
      onMouseEnter: this.onMouseEnter,
      onMouseLeave: this.onMouseLeave,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      onPress: this.onPress,
      onPressIn: this.onPressIn,
      onPressOut: this.onPressOut
    }), /*#__PURE__*/React.createElement(View, {
      style: styles.highlightContainer
    }, /*#__PURE__*/React.createElement(View, {
      style: [evaStyle.highlight, styles.highlight]
    }), /*#__PURE__*/React.createElement(View, {
      style: [evaStyle.selectContainer, styles.selectContainer]
    }, this.renderIconElement(evaStyle.icon))), /*#__PURE__*/React.createElement(FalsyText, {
      style: evaStyle.text,
      component: children
    }));
  }

}, _temp)) || _class);
const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  highlightContainer: {
    justifyContent: 'center',
    alignItems: 'center'
  },
  selectContainer: {
    justifyContent: 'center',
    alignItems: 'center'
  },
  highlight: {
    position: 'absolute'
  }
});